import React from 'react';
import clsx from 'classnames';
import './index.css';
import Banner from './components/Banner';
import Product from './components/Product';
import Construction from './components/Construction';
import Service from './components/Service';
import News from './components/News';

const HomePage = () => {
  return (
    <div className={clsx('page-top')} style={{ minHeight: window.innerHeight }}>
      {/* Banner轮播图 */}
      <Banner />
      {/* 实验室建设 */}
      <Construction />
      {/* 最新产品 */}
      <Product />
      {/* 服务内容 */}
      <Service />
      {/* 新闻中心 */}
      <News />
    </div>
  );
};

export default HomePage;
